module.exports = __webpack_public_path__ + "img/07.5950c648.jpg";